import * as React from 'react';
import { get } from 'lodash';
import { compose, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form';
import { Row, Col, Grid } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import { rebukeDelict } from '@modules/delicts/_delictsActions';
import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<any, any>(
  withNotifications({ rebukeDelict }),
  withHandlers({
    onSubmit: ({ reloadDelict, delictId, closeItem, rebukeDelictNotify }) => async formData => {
      const result = await rebukeDelictNotify({ id: delictId, ...formData });
      if (result) {
        await reloadDelict();
        closeItem();
      }
    }
  }),
  reduxForm({ form: 'module-events-delicts-agreement' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Domluva</h4>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name={'employeeId'}
                  label={'Strážník'}
                  url={'/metropolis/api/hr/employees'}
                  fullWidth={true}
                  labelFunction={o => get(o, 'fullName')}
                  valueFunction={o => get(o, 'id')}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Button label="Uložit a zavřít" primary={true} type={'submit'} style={{ margin: '8px' }} />
        <Button label="Zrušit" style={{ margin: '8px' }} onClick={closeItem} />
      </Grid>
    </form>
  </div>
);

export const EventsFormDelictsAgreementForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDelictsAgreementForm.tsx